import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["elementData", "innerRef", "disabled", "disabledMessage"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import EPAddableObject from 'editor-components/sidebar/addableComponents/EPAddableObject';
import WidgetIcon from 'ContentComponents/components/cmv2/WidgetIcon';
import SidebarTooltip from 'LayoutBuilderUI/containers/SidebarTooltip';
// @ts-expect-error no declarations found for module
import withDraggableElement from 'LayoutBuilderUI/hoc/withDraggableElement';
import storeInRecentlyUsedModules from 'LayoutBuilderUI/utils/storeInRecentlyUsedModules';
import EmailV3RenderingTooltipMessage from 'LayoutBuilderUI/components/extras/EmailV3RenderingTooltipMessage';
import { getIsNewModule, getIsBetaModule
// @ts-expect-error no declarations found for module
} from 'EmailEditorUI/utils/moduleUtils';

//this is Partial description of ElementData, should be replaced with correct type when we have it
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MoveableTile = _ref => {
  let {
      elementData = {},
      innerRef,
      disabled,
      disabledMessage
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const label = elementData.displayName || elementData.name;
  const renderRibbon = () => {
    if (elementData.isEnabledForEmailV3Rendering || getIsBetaModule(elementData.moduleId)) {
      return /*#__PURE__*/_jsx(Ribbon, {
        use: "beta",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CrossFrame.elements.label.beta"
        })
      });
    } else if (getIsNewModule(elementData.moduleId)) {
      return /*#__PURE__*/_jsx(Ribbon, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CrossFrame.elements.label.new"
        })
      });
    }
    return null;
  };
  const addableObject = /*#__PURE__*/_jsx("div", {
    ref: innerRef,
    children: /*#__PURE__*/_jsxs(View, {
      position: "relative",
      children: [/*#__PURE__*/_jsx(EPAddableObject, Object.assign({
        useOnDark: true,
        iconNode: /*#__PURE__*/_jsx(Flex, {
          children: /*#__PURE__*/_jsx(WidgetIcon, {
            size: 20,
            color: disabled ? 'icon-primary-disabled' : 'icon-core-subtle',
            icon: elementData.icon
          })
        }),
        text: label,
        "data-module-name": elementData.name,
        "data-module-id": elementData.moduleId
      }, otherProps)), renderRibbon()]
    })
  });
  if (elementData.isEnabledForEmailV3Rendering) {
    return /*#__PURE__*/_jsx(SidebarTooltip, {
      title: /*#__PURE__*/_jsx(EmailV3RenderingTooltipMessage, {}),
      placement: "top",
      children: addableObject
    });
  }
  if (disabled) {
    return /*#__PURE__*/_jsx(SidebarTooltip, {
      title: disabledMessage,
      placement: "top",
      children: addableObject
    });
  }
  return addableObject;
};
export default withDraggableElement(MoveableTile, storeInRecentlyUsedModules);